import { BaseReducer } from '@identic/api';
import { ImportState, ImportInitialState, ImportActions } from './import.state';

export function ImportReducer(state: ImportState = ImportInitialState, action: any): ImportState {
  return BaseReducer(state, action, ImportActions);
}
// console.log(`%cImportReducer::ngOnInit`, 'background:yellow');
